import { LocalizationKeys, type LocalizationKey } from '../../i18n/keys'

/**
 * Content Type enum
 */
export enum ContentType {
  UNSPECIFIED = 0,
  MOVIE = 1,
  BOOK = 2,
  TV_SHOW = 3,
  COMICS = 4,
  GAME = 5,
}

/**
 * i18n keys for ContentType enum values
 */
export const CONTENT_TYPE_I18N_KEYS: Record<ContentType, LocalizationKey> = {
  [ContentType.UNSPECIFIED]: LocalizationKeys.CONTENT_TYPE_UNSPECIFIED,
  [ContentType.MOVIE]: LocalizationKeys.CONTENT_TYPE_MOVIE,
  [ContentType.BOOK]: LocalizationKeys.CONTENT_TYPE_BOOK,
  [ContentType.TV_SHOW]: LocalizationKeys.CONTENT_TYPE_TV_SHOW,
  [ContentType.COMICS]: LocalizationKeys.CONTENT_TYPE_COMICS,
  [ContentType.GAME]: LocalizationKeys.CONTENT_TYPE_GAME,
}
